import React, { FunctionComponent } from 'react';
import FrontChatWidget from '~/components/FrontChatWidget';
import ToastContainer from '~/components/ToastContainer';
import Recaptcha from '~/components/Recaptcha';
import ModalsWrapper, {
  type ModalsWrapperProps,
} from '~/components/ModalsWrapper';

export interface CommonWrapperProps extends ModalsWrapperProps {
  children: JSX.Element | JSX.Element[];
  showHelp?: boolean;
  recaptcha?: boolean;
}

const CommonWrapper: FunctionComponent<CommonWrapperProps> = function ({
  children,
  showHelp = true,
  recaptcha = false,
}) {
  return (
    <ModalsWrapper>
      <>
        {showHelp && <FrontChatWidget />}
        {recaptcha && <Recaptcha />}
        <ToastContainer />
        <>{children}</>
      </>
    </ModalsWrapper>
  );
};

export default CommonWrapper;
